import React from 'react';

import './blackBox.scss';

export const BlackBox = (props) => {
  const { title, subtitle } = props;

  return (
    <div className="black-box">
      <h3>{title}</h3>
      <text>{subtitle}</text>
    </div>
  );
};
